// extracted by mini-css-extract-plugin
export var container = "person-module--container--tYOZ3";
export var img = "person-module--img--hmQP7";
export var partyD = "person-module--party-D--VG791";
export var partyDDots = "person-module--party-D-dots--Om1qD";
export var partyInd = "person-module--party-Ind--2AKvC";
export var partyIndDots = "person-module--party-Ind-dots--hud-Q";
export var partyR = "person-module--party-R--ApHgJ";
export var partyRDots = "person-module--party-R-dots--Rkjjq";